// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion-button::before {
  content: "+";
  padding-right: 15px;
  font-size: 35px;
  margin-top: -5px;
}

.accordion-button:not(.collapsed)::before {
  content: "-";
  padding-right: 15px;
  font-size: 35px;
}

.accordion-button::after {
  content: none;
}

.e-accordion .e-tgl-collapse-icon.e-expand-icon::before {
  content: "\\e934";
}

.faq-custom-container {
  display: flex;
  flex-wrap: nowrap;
  align-content: flex-start;
  justify-content: flex-start;
  align-items: flex-start;
  padding-left: 20px;
}
.faq-custom-container .accordion-item {
  border-left: none;
  border-right: none;
}
.faq-custom-container .accordion-item:nth-child(1) {
  border-top: none;
}
.faq-custom-container .accordion-button:focus {
  box-shadow: none !important;
}
.faq-custom-container .faq-options {
  margin-bottom: 50px;
}
.faq-custom-container .faq-options .btn-default {
  margin-right: 10px;
  width: 111px;
  height: 40px;
  border-radius: 24px;
  padding: 8px 24px 8px 24px;
  border: 1px solid #fff;
  font-weight: 600;
}
.faq-custom-container .faq-options .btn-default.active {
  border: none;
  gap: 8px;
  background-color: #0084ff;
  color: #fefefe;
}
.faq-custom-container .faq-custom-header {
  display: flex;
  margin: 0 25px;
  flex-wrap: nowrap;
  flex-direction: column;
  margin: 40px 0;
}
.faq-custom-container .faq-custom-header h1 {
  font-size: 44px;
  font-weight: 700;
}
.faq-custom-container .faq-custom-header small {
  color: #6C7275;
  font-size: 20px;
}
.faq-custom-container .faq-custom-content {
  display: flex;
  margin: 0 25px;
  flex-wrap: nowrap;
  flex-direction: column;
  width: 800px;
}
.faq-custom-container .faq-container {
  display: flex;
  flex-direction: column;
}
.faq-custom-container .faq-container .accordion {
  overflow-y: auto;
  overflow-x: hidden;
}
.faq-custom-container .faq-container .accordion-button:not(.collapsed) {
  color: #000;
  background-color: #fff;
}
.faq-custom-container .faq-container .accordion-button:focus {
  border-color: transparent;
  outline-color: rgb(33, 37, 41);
}
.faq-custom-container .faq-container button:focus:not(:focus-visible) {
  outline-color: rgb(33, 37, 41);
}
.faq-custom-container .faq-container .accordion-body {
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.02em;
  text-align: left;
  color: #6c7275;
}

.support-block {
  background-color: #F9FAFA;
  min-height: 100px;
  width: 100%;
  margin-bottom: 50px;
  margin-top: 100px;
  border-radius: 20px;
  padding: 60px 20px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.support-block h3 {
  margin-bottom: 5px;
  color: #141718;
  font-weight: 600;
  font-size: 24px;
}
.support-block div {
  color: #6C7275;
  font-size: 16px;
}

.logo-monkey {
  background-color: #0084ff;
  width: 64px;
  padding: 6px;
  border-radius: 16px;
  margin-bottom: 30px;
}

.email-support {
  width: fit-content;
  min-width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  padding: 10px 30px;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Logged/Styles/faq.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,iBAAA;EACA,yBAAA;EACA,2BAAA;EACA,uBAAA;EACA,kBAAA;AACF;AACE;EACE,iBAAA;EACA,kBAAA;AACJ;AACI;EACE,gBAAA;AACN;AAKE;EACE,2BAAA;AAHJ;AAME;EACE,mBAAA;AAJJ;AAMI;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,0BAAA;EACA,sBAAA;EACA,gBAAA;AAJN;AAMM;EACE,YAAA;EACA,QAAA;EACA,yBAAA;EACA,cAAA;AAJR;AAUE;EACE,aAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;AARJ;AAUI;EACE,eAAA;EACA,gBAAA;AARN;AAWI;EACE,cAAA;EACA,eAAA;AATN;AAaE;EACE,aAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,YAAA;AAXJ;AAcE;EACE,aAAA;EACA,sBAAA;AAZJ;AAcI;EACE,gBAAA;EACA,kBAAA;AAZN;AAeI;EACE,WAAA;EACA,sBAAA;AAbN;AAgBI;EACE,yBAAA;EACA,8BAAA;AAdN;AAiBI;EACE,8BAAA;AAfN;AAkBI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;AAhBN;;AAqBA;EACE,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AAlBF;AAoBE;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAlBJ;AAqBE;EACE,cAAA;EACA,eAAA;AAnBJ;;AAuBA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AApBF;;AAuBA;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AApBF","sourcesContent":[".accordion-button::before {\n  content: \"+\";\n  padding-right: 15px;\n  font-size: 35px;\n  margin-top: -5px;\n}\n\n.accordion-button:not(.collapsed)::before {\n  content: \"-\";\n  padding-right: 15px;\n  font-size: 35px;\n}\n\n.accordion-button::after {\n  content: none;\n}\n\n.e-accordion .e-tgl-collapse-icon.e-expand-icon::before {\n  content: \"\\e934\";\n}\n\n.faq-custom-container {\n  display: flex;\n  flex-wrap: nowrap;\n  align-content: flex-start;\n  justify-content: flex-start;\n  align-items: flex-start;\n  padding-left: 20px;\n\n  .accordion-item {\n    border-left: none;\n    border-right: none;\n\n    &:nth-child(1) {\n      border-top: none;\n    }\n\n\n  }\n\n  .accordion-button:focus {\n    box-shadow: none !important;\n  }\n\n  .faq-options {\n    margin-bottom: 50px;\n\n    .btn-default {\n      margin-right: 10px;\n      width: 111px;\n      height: 40px;\n      border-radius: 24px;\n      padding: 8px 24px 8px 24px;\n      border: 1px solid #fff;\n      font-weight: 600;\n\n      &.active {\n        border: none;\n        gap: 8px;\n        background-color: #0084ff;\n        color: #fefefe;\n\n      }\n    }\n  }\n\n  .faq-custom-header {\n    display: flex;\n    margin: 0 25px;\n    flex-wrap: nowrap;\n    flex-direction: column;\n    margin: 40px 0;\n\n    h1 {\n      font-size: 44px;\n      font-weight: 700;\n    }\n\n    small {\n      color: #6C7275;\n      font-size: 20px;\n    }\n  }\n\n  .faq-custom-content {\n    display: flex;\n    margin: 0 25px;\n    flex-wrap: nowrap;\n    flex-direction: column;\n    width: 800px;\n  }\n\n  .faq-container {\n    display: flex;\n    flex-direction: column;\n\n    .accordion {\n      overflow-y: auto;\n      overflow-x: hidden;\n    }\n\n    .accordion-button:not(.collapsed) {\n      color: #000;\n      background-color: #fff;\n    }\n\n    .accordion-button:focus {\n      border-color: transparent;\n      outline-color: rgb(33, 37, 41);\n    }\n\n    button:focus:not(:focus-visible) {\n      outline-color: rgb(33, 37, 41);\n    }\n\n    .accordion-body {\n      font-size: 14px;\n      font-weight: 500;\n      line-height: 24px;\n      letter-spacing: -0.02em;\n      text-align: left;\n      color: #6c7275;\n    }\n  }\n}\n\n.support-block {\n  background-color: #F9FAFA;\n  min-height: 100px;\n  width: 100%;\n  margin-bottom: 50px;\n  margin-top: 100px;\n  border-radius: 20px;\n  padding: 60px 20px;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n\n  h3 {\n    margin-bottom: 5px;\n    color: #141718;\n    font-weight: 600;\n    font-size: 24px;\n  }\n\n  div {\n    color: #6C7275;\n    font-size: 16px;\n  }\n}\n\n.logo-monkey {\n  background-color: #0084ff;\n  width: 64px;\n  padding: 6px;\n  border-radius: 16px;\n  margin-bottom: 30px;\n}\n\n.email-support {\n  width: fit-content;\n  min-width: 100px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 30px;\n  padding: 10px 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
